import Lookup from 'src/componentes/select2';

const NivelDicionarioRiscoLookup = ({ ...rest }) => {
  const options = [
    { id: 1, descricao: '1' },
    { id: 2, descricao: '2' },
    { id: 3, descricao: '3' },
  ];

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      options={options}
      clearable
      {...rest}
    />
  );
};

export default NivelDicionarioRiscoLookup;
